import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, useIsMobile, useT } from '@repo/common';
import HiddenJobs from '../../components/JobBoard/Hidden/HiddenJobs';
import { ReactComponent as NavigationLeftIcon } from '@repo/common/assets/icons/20px/icon_20px_navigation-left.svg';

const JobHidden = () => {
  const t = useT();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleBackToMenu = () => {
    navigate('/mypage?tab=My%20Apply');
  };

  return (
    <div className='bg-grayscale-gray01 flex min-h-screen flex-col tabletH:min-h-0 tabletH:items-center justify-start tabletH:justify-center tabletH:p-10 tabletH:pb-[320px] w-full animate-slideUp tabletH:animate-none'>
      {isMobile && (
        <>
          <BaseButton
            type='text'
            size='m'
            hideIcon
            typo={false}
            isStatic
            leftalign
            onClick={handleBackToMenu}
            textWrapperClass='h-auto'
            className='min-w-0 cursor-pointer rounded-none border-0 px-4 py-1.5 bg-grayscale-gray01 h-[54px]'
          >
            <div className='flex items-center gap-2 typo-title2 text-text-primary'>
              <NavigationLeftIcon />
              {t('Hidden Jobs', '숨긴 공고')}
            </div>
          </BaseButton>
        </>
      )}

      <HiddenJobs />
    </div>
  );
};

export default JobHidden;
